import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
  TYPE_INSTANCE5,
} from "App/constants";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";
import InputCheckboxMaster from "App/Component/ui/input/InputCheckboxMaster/InputCheckboxMaster";
import { LIST_URL_AKUNTANSI } from "utils/akuntansi";
import { useMultipleSelect } from "hooks";
import { validasiMultipleSelect } from "hooks/useMultipleSelect";

export const RESET_STATE_KAS = {
  id: "",
  id_coa: "",
  nama_coa: "",
  nama: "",
  jumlah2: "",
  no_rek: "",
  no_hp: "",
  telepon: null,
  no_contact_person: null,
  status: true,
  remark: "",
  is_bayar_saldo: false,
  is_penjualan: false,
  is_bayar_tagihan: false,
};

export const urlGet = LIST_URL_MASTER.kas.list;
export const urlAdd = LIST_URL_MASTER.kas.add;
export const urlUpdate = LIST_URL_MASTER.kas.update;
export const urlDelete = LIST_URL_MASTER.kas.delete;

export const deleteKasById = async (id) => {
  try {
    const res = await instance3.post(urlDelete, {
      id,
    });

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "coa_name",
    disablePadding: false,
    label: "COA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    sort: false,
  },
  {
    id: "no_rek",
    disablePadding: false,
    label: "NOREK",
    align: "left",
    sort: false,
  },
  {
    id: "no_hp",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "is_bayar_saldo",
    disablePadding: false,
    label: "PEMBAYARAN SALDO",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "is_penjualan",
    disablePadding: false,
    label: "INPUT PENJUALAN",
    align: "left",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "is_bayar_tagihan",
    disablePadding: false,
    label: "PEMBAYARAN TAGIHAN",
    align: "left",
    sort: false,
    minWidth: "160px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance3.post(urlAdd, {
      ...formData,
      jumlah: convertToValidPrice(formData.jumlah2),
    });
  };

  const update = () => {
    console.log("FormDta", formData);
    return instance3.post(urlUpdate, {
      ...formData,
      jumlah: convertToValidPrice(formData.jumlah2),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.nama === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          const res = await add();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil menambah data");
            await setNewData();
            setShowModal(false);
          } else {
            defaultToastError(res.data.message);
          }
        } else if (formData.id !== "") {
          const res = await update();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil mengubah data");
            await setNewData();
            setShowModal(false);
          } else {
            defaultToastError(res.data.message);
          }
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_KAS);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const coa = useMultipleSelect([
    {
      url: LIST_URL_AKUNTANSI.coa.getByLevel,
      search: true,
      type_instance: TYPE_INSTANCE5,
      value: "id",
      label: ["name", "code"],
      options: { headers: { level: 4 } },
      type_response: "body",
      key: "name",
      attr_addition: ["name","code"],
      attr_addition_value: ["name","code"],
    },
  ]);


  return (
    <Modal title={`${titleModal(formData.id)} Kas`} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='nama'
              label='Nama'
              id='nama'
              value={formData.nama}
              onChange={handleChange("nama")}
              placeholder='Nama'
            />
          </Grid>
          <Grid item sm={12}>
            <InputOptionMaster
              name='coa_id'
              label='COA'
              id='coa_id'
              withSearch={true}
              data={validasiMultipleSelect(coa, 0)}
              code={formData.id_coa}
              value={formData.id_coa}
              labelValue={formData.nama_coa}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    id_coa: null,
                    nama_coa: "Pilih COA",
                  });
                } else {
                  setFormData({
                    ...formData,
                    id_coa: e.code,
                    nama_coa: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='jumlah2'
              label='JUMLAH'
              id='jumlah2'
              value={formData.jumlah2}
              onChange={(e) => {
                let val = e.target.value;
                if (!isNull(val)) {
                  setFormData({
                    ...formData,
                    jumlah2: formatRupiah(val),
                  });
                }
              }}
              placeholder='Jumlah'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='no_rek'
              label='NOREK'
              id='no_rek'
              value={formData.no_rek}
              onChange={handleChange("no_rek")}
              placeholder='Norek'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='no_hp'
              label='NO HP'
              id='no_hp'
              value={formData.no_hp}
              onChange={handleChange("no_hp")}
              placeholder='No HP'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='telepon'
              label='TELEPHONE'
              id='telepon'
              value={formData.telepon}
              onChange={handleChange("telepon")}
              placeholder='Telephone'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='no_contact_person'
              label='NO CONTACT PERSON'
              id='no_contact_person'
              value={formData.no_contact_person}
              onChange={handleChange("no_contact_person")}
              placeholder='No Contact Person'
            />
          </Grid>
          <Grid item sm={4}>
            <InputCheckboxMaster
              checked={formData.is_bayar_saldo}
              name='is_bayar_saldo'
              id='is_bayar_saldo'
              label='PEMBAYARAN SALDO'
              onChange={() =>
                setFormData({
                  ...formData,
                  is_bayar_saldo: !formData.is_bayar_saldo,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputCheckboxMaster
              checked={formData.is_penjualan}
              name='is_penjualan'
              id='is_penjualan'
              label='INPUT PENJUALAN'
              onChange={() =>
                setFormData({
                  ...formData,
                  is_penjualan: !formData.is_penjualan,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputCheckboxMaster
              checked={formData.is_bayar_tagihan}
              name='is_bayar_tagihan'
              id='is_bayar_tagihan'
              label='PEMBAYARAN TAGIHAN'
              onChange={() =>
                setFormData({
                  ...formData,
                  is_bayar_tagihan: !formData.is_bayar_tagihan,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
